<template>
    <modal
        name="modal-denied-access"
        height="auto"
    >
        <div class="container">
            <div class="img-wrapper">
                <img class="img" src="../../assets/images/laptop-login.png"/>
            </div>
            <div class="body-title-wrapper">
                <div class="body-title">¡Inicia sesión en el Portal de Corredores!</div>
            </div>
            <div class="body-content-wrapper">
                <div class="body-content">Ahora el ingreso al Gestor de Cotizaciones es desde el Portal de Corredores</div>
            </div>
            <div class="buttons-wrapper">
                <a href="https://web-test.lapositiva.com.pe/Login_UI/" class="primary-button-xs">Ir al portal de corredores</a>
            </div>
        </div>
    </modal>
</template>
<script>

export default {
    name:"modal-denied-access",
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';
.container{
    padding: 75px 35px 0 35px;
    background-color: #fff;
    border: 1px solid #e8e8e8;
    box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.14);
    height: auto;
}
.img-wrapper{
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
}
.img{
    width: 260px;
    height: 175px;
}
.header-title{
    color: #2a2a2e;
    font-family: 'miraimedium';
    font-size: 1.125em;
}
.body-title-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
}
.body-content-wrapper {
    justify-content: center;
    margin-bottom: 30px;
}
.body-content {
    font-size: 20px;
    color: $bold-grey;
    text-align: center;
}
.body-title {
    font-size: 28px;
    color: $primary;
}
.buttons-wrapper{
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
}

</style>